const flowFileDl = {
	ui: {},

	init: function() {
		this.bindUI();
		this.bindEvents();
	},

	bindUI: function bindUI() {
		this.ui.$fileDl = $(".js-flow-file-dl");
		this.ui.$fileLink = $(".js-flow-file-dl-validation");
	},

	bindEvents: function bindEvents() {
        $(document).on('gform_confirmation_loaded', (event, formId) => this.onSubmit(event, formId));
    },

	onSubmit: function(event, formId) {
        let id = this.ui.$fileDl.attr('data-form-id') || false

        // Must check like this because we generate random ID on gravity forms
        let $gform = $('#gf_'+formId);
        if ($gform.length) {
            let submitted_form_id = $gform.closest('.js-flow-file-dl').attr('data-form-id');
            if (id && parseInt(id) === parseInt(submitted_form_id)) {
                this.ui.$fileDl.addClass('is-valid')
                this.ui.$fileLink[0].click()
            }
        }
	},
};

module.exports = flowFileDl;
